/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_Rate_LabelInputs */

const en_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sampling Rate (seconds)`)
};

const fr_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence d'échantillonnage (secondes)`)
};

const de_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abtastrate (Sekunden)`)
};

const it_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza di campionamento (secondi)`)
};

const ru_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота дискретизации (в секундах)`)
};

const es_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frecuencia de muestreo (segundos)`)
};

const zh_cn2_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`采样率（秒）`)
};

const ja_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプリングレート（秒）`)
};

const hi_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नमूनाकरण दर (सेकंड)`)
};

const pt_pt2_ocr_sampling_rate_label = /** @type {(inputs: Ocr_Sampling_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de amostragem (segundos)`)
};

/**
* | output |
* | --- |
* | "Sampling Rate (seconds)" |
*
* @param {Ocr_Sampling_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_rate_label = /** @type {((inputs?: Ocr_Sampling_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_sampling_rate_label(inputs)
	if (locale === "de") return de_ocr_sampling_rate_label(inputs)
	if (locale === "it") return it_ocr_sampling_rate_label(inputs)
	if (locale === "ru") return ru_ocr_sampling_rate_label(inputs)
	if (locale === "es") return es_ocr_sampling_rate_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_sampling_rate_label(inputs)
	if (locale === "ja") return ja_ocr_sampling_rate_label(inputs)
	if (locale === "hi") return hi_ocr_sampling_rate_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_sampling_rate_label(inputs)
	return en_ocr_sampling_rate_label(inputs)
});